import $ from 'jquery';

export default class FaqManage {
  constructor($scope, $filter, FaqService) {
    $scope.types = [
      {
        id: 1,
        title: 'Users'
      },
      {
        id: 2,
        title: 'Offers'
      },
      {
        id: 3,
        title: 'Demands'
      },
      {
        id: 4,
        title: 'Orders'
      }
    ];

    $scope.show_section_faqs = function(type, section) {
      $scope.selected_section = section;
      $scope.section_breadcrumb = $scope.get_section_breadcrumb();
      $scope.selected_type = type;
      $scope.loading = true;
      FaqService.get_section_faqs(section).then(function(data) {
        $scope.faqs = data.faqs;
        $scope.loading = false;
      });
    };

    $scope.get_section_breadcrumb = function() {
      if (!$scope.selected_section.parent_id) {
        return $scope.selected_section.title;
      } else {
        var section = $filter('filter')($scope.sections, {
          id: $scope.selected_section.parent_id
        })[0];
        return section.title + ' / ' + $scope.selected_section.title;
      }
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.add_faq = function() {
      $scope.dialog_faq = {
        faq_type_id: 1,
        faq_sections: [4, null],
        question: null,
        answer: null,
        weight: 0,
        is_visible: 1
      };
      $scope.open_dialog('faq_dialog');
    };

    $scope.edit_faq = function(faq) {
      $scope.dialog_faq = faq;
      var faq_section = $filter('filter')($scope.sections, {
        id: faq.faq_section_id
      })[0];
      if (!faq_section.parent_id)
        $scope.dialog_faq.faq_sections = [faq_section.id, null];
      else
        $scope.dialog_faq.faq_sections = [faq_section.parent_id, faq_section.id];
      $scope.open_dialog('faq_dialog');
    };

    $scope.delete_faq = function(index) {
      if (confirm('Are you sure you want to delete this FAQ?')) {
        FaqService.delete($scope.faqs[index].id).then(function(data) {
          if (data.success)
            $scope.faqs.splice(index, 1);
        });
      }
    };

    $scope.save_faq = function() {
      $scope.updating = true;
      $scope.dialog_faq.faq_section_id = $scope.dialog_faq.faq_sections[1] ? $scope.dialog_faq.faq_sections[1] : $scope.dialog_faq.faq_sections[0];
      FaqService.save($scope.dialog_faq).then(function(data) {
        if (data.success) {
          $scope.updating = false;
          $.fancybox.close();
          var type = $filter('filter')($scope.types, {
            id: $scope.dialog_faq.faq_type_id
          })[0];
          var section = $filter('filter')($scope.sections, {
            id: $scope.dialog_faq.faq_section_id
          })[0];
          $scope.show_section_faqs(type, section);
        }
      });
    };

    $scope.init = function() {
      $scope.sections = window.sections;
      $scope.show_section_faqs($scope.types[0], $scope.sections[0]);
    };

    $scope.init();
  }
}

FaqManage.$inject = ['$scope', '$filter', 'FaqService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/faq-manage.ctrl.js